export const checkRadioValue = (
  fieldValue: string,
  conditionalValue: string
) => {
  if (conditionalValue.toLowerCase() === 'yes') {
    return fieldValue.toLowerCase() === 'true';
  }
  if (conditionalValue.toLowerCase() === 'no') {
    return fieldValue.toLowerCase() === 'false';
  }
  return fieldValue === conditionalValue;
};

export default checkRadioValue;
